function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#AuctionEmptyImage_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.39 153.96s-2.78-6.825 5.56-11.943l-5.56 11.943zM28.97 153.837s-.848-4.865-7.412-4.823l7.413 4.823zM125.488 153.96s-2.78-6.825 5.561-11.943l-5.561 11.943zM122.069 153.837s-.848-4.865-7.413-4.823l7.413 4.823zM123.198 109.77c13.348 0 24.169-10.79 24.169-24.101s-10.821-24.102-24.169-24.102-24.17 10.79-24.17 24.102c0 13.31 10.822 24.101 24.17 24.101z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.264 85.669h.067L124.526 154h-2.523l1.261-68.331zM175.089 121.741c9.736 0 17.629-7.871 17.629-17.579 0-9.709-7.893-17.579-17.629-17.579s-17.628 7.87-17.628 17.579c0 9.708 7.892 17.579 17.628 17.579z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.138 104.161h.048l.872 49.839h-1.84l.92-49.839z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.473 104.34a2.326 2.326 0 002.035-1.966c.05-.335.024-.677-.073-1.002l6.701-4.82-4.014-1.52-5.748 4.81a2.334 2.334 0 00-1.454 2.736 2.333 2.333 0 002.553 1.762zM72.56 151.617h-2.128l-1.012-8.184h3.14v8.184z",
  fill: "#FFB6B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.102 153.673l-6.861-.001v-.086c0-.706.281-1.384.782-1.883.5-.5 1.18-.78 1.888-.78h4.19v2.75z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.307 151.617H54.18l-1.013-8.184h3.14v8.184z",
  fill: "#FFB6B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.85 153.673l-6.861-.001v-.086c0-.706.281-1.384.782-1.883.5-.5 1.18-.78 1.888-.78h4.19v2.75zM57.95 106.106l-4.509 24.59-1.577 19.533 5.12-.251L59.9 131.01l7.245-16.515 2.157 35.437 4.713.015 2.537-44.825-18.6.984z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.128 77.96l-6.32-2.508-7.251.827-6.147 3.389s1.88 23.515-.845 29.031c0 0 2.184 3.016 11.082 2.28 0 0 8.667-1.092 8.882-3.927.215-2.834.26-7.987.26-7.987l3.009-10.338-2.67-10.767z",
  fill: "#FF3B31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.88 80.12l-2.47-.452s-2.63 1.15-2.602 4.575c.027 3.425-4.645 14.908.944 15.39 5.589.481 4.128-8.144 4.128-8.144V80.121zM75.123 79.42l2.005-1.46s3.06.69 4.192 3.146c0 0 12.552 9.077 9.1 12.52-3.453 3.442-10.49 7.679-10.49 7.679l-2.606-2.941 6.465-5.84-5.304-4.818-3.362-8.287z",
  fill: "#FF3B31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.918 68.932a5.167 5.167 0 01-1.52 3.657 5.197 5.197 0 01-7.336 0 5.167 5.167 0 01-1.521-3.657v-.198a5.168 5.168 0 011.624-3.562 5.197 5.197 0 017.263.14 5.167 5.167 0 011.487 3.62h.003z",
  fill: "#FFB6B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.518 68.098c.332-.055.692-.106.989.046.647.33.498 1.265.851 1.882.14.245.365.445.458.71.093.264.036.595.182.85.211.37.783.424 1.16.205.355-.246.612-.608.727-1.024.125-.352.23-.741.53-.972.11-.062.209-.142.292-.237a.712.712 0 00.069-.405c0-.895-.14-1.589.064-2.456.325-1.398.622-2.09-.408-3.126a3.568 3.568 0 00-1.941-.99c-.664-.11-1.641.815-2.313.794-1.71-.068-3.151-1.646-4.78-1.136a3.361 3.361 0 00-1.756 1.288c-.796 1.17-.725 1.623-.61 3.02 0 .106.03.21.09.298.06.072.157.11.215.183a.45.45 0 01.066.326c-.017.227-.07.45-.158.662a.272.272 0 00-.024.238c.033.044.08.076.133.09.664.238 1.381-.221 2.091-.21.71.013 1.385.487 2.118.384.647-.1 1.303-.313 1.955-.42z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.483 96.865a.619.619 0 01-.137.035l-5.762.802a.621.621 0 01-.667-.392l-4.96-12.869a.62.62 0 01.446-.829l5.418-1.206a.495.495 0 00.12-.044l5.27-2.747a.617.617 0 01.129-.05l5.8-1.542a.623.623 0 01.741.377l4.325 11.221a.615.615 0 01-.082.594l-1.495 2.003a.622.622 0 01-.277.209l-3.268 1.252a.497.497 0 00-.068.032l-5.446 3.113a.615.615 0 01-.087.041z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.165 79.738l-.737.196-1.952.519h-.003L64.8 81.848l-.992.517-1.49.777-.04.009-1.548.344-.748.167-3.05.678 4.788 12.424 3.143-.438.77-.107 1.643-.229.02-.002 5.277-3.017 3.211-1.23 1.467-1.964-4.168-10.814-2.92.776z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.77 80.744L57.894 86.83l.272.706 15.878-6.085-.272-.706zM74.676 83.096L58.8 89.18l.272.705 15.877-6.085-.272-.705zM76.507 87.846L60.629 93.93l.272.705 15.878-6.085-.272-.705z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.165 79.738l4.753 12.334-.707.272-4.783-12.41.737-.196zM64.8 81.847l-.976 2.708-.338.94-.79 2.191-.169.469-.17.47-.222.619-1.6 4.44-.416-1.079 1.304-3.621.295-.82.044-.12.349-.97.44-1.221.339-.94.918-2.549.992-.517z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.73 83.494l4.904 12.724-.77.108-4.881-12.665.748-.167z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M59.681 95.678a2.254 2.254 0 002.258-2.25c0-1.243-1.01-2.251-2.258-2.251a2.254 2.254 0 00-2.257 2.25c0 1.244 1.01 2.251 2.258 2.251z",
  fill: "#FFB6B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.889 79.999c22.153 0 40.112-17.908 40.112-40C193.001 17.91 175.042 0 152.889 0c-22.154 0-40.113 17.908-40.113 40 0 22.09 17.959 39.999 40.113 39.999z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.778 39.999h-.111l-1.983 113.405h4.187l-2.093-113.405z",
  fill: "#E4E4E4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M182.055 153.888H.218a.218.218 0 010-.435h181.837a.217.217 0 110 .435z",
  fill: "#CACACA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.673 80c22.091 0 40-17.909 40-40s-17.909-40-40-40c-22.092 0-40 17.909-40 40s17.908 40 40 40z",
  fill: "#E6E6E6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.739 17.05a4.59 4.59 0 100-9.18 4.59 4.59 0 000 9.18zM156.607 62.95a4.59 4.59 0 100-9.18 4.59 4.59 0 000 9.18zM174.312 36.065a3.279 3.279 0 100-6.557 3.279 3.279 0 000 6.557zM136.935 53.77c5.795 0 10.492-4.697 10.492-10.491 0-5.795-4.697-10.492-10.492-10.492-5.794 0-10.492 4.697-10.492 10.492 0 5.794 4.698 10.492 10.492 10.492z",
  fill: "#CBCBCB"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M182.506 13.283a39.902 39.902 0 011.432 27.564 40.02 40.02 0 01-16.81 21.928 40.21 40.21 0 01-27.05 5.852 40.15 40.15 0 01-24.411-13.01 40 40 0 0010.026 13.989 40.147 40.147 0 0014.987 8.499 40.222 40.222 0 0033.382-4.443A40.064 40.064 0 00186.29 61.54a39.94 39.94 0 005.995-16.12 39.892 39.892 0 00-1.344-17.142 39.983 39.983 0 00-8.435-14.995z",
  fill: "#000"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "AuctionEmptyImage_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h193v154H0z"
})));

function SvgAuctionEmptyImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 154,
    viewBox: "0 0 193 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgAuctionEmptyImage;